<template>
  <com-solt :isShopView="isShopView" :GetShopInfoNoLogin="GetShopInfoNoLogin">
    <div class="main">
      <div class="content container1">
        <div class="img">
          <img src="@/assets/img/login_new_01.png" alt />
        </div>
        <div class="adv">
          <p class="p1">大牌精选</p>
          <p class="p2">品质无忧</p>
        </div>
        <!-- 账户、手机登录 -->
        <div class="form_box" v-show="login_Type!=='wx'">
          <!-- 账户、手机登录入口 -->
          <div class="menu">
            <div :class="{item:true,active:login_Type==='pwd'}" @click="changeLoginType('pwd')">账户登录</div>
            <div :class="{item:true,active:login_Type==='mobile'}" @click="changeLoginType('mobile')">快捷登录</div>
          </div>
          <!-- 账户登录 -->
          <el-form v-show="login_Type==='pwd'" ref="form" :model="dataLogin" :rules="rules" label-width="0px" label-position="left">
            <el-form-item prop="userAccount">
              <el-input v-model.trim="dataLogin.userAccount" placeholder="请输入用户名" clearable></el-input>
              <img class="ipt_img" src="@/assets/img/login_new_02.png" alt />
            </el-form-item>
            <el-form-item prop="userPwd" class="pwd_item">
              <el-input v-model.trim="dataLogin.userPwd" show-password clearable placeholder="请输入密码" @keyup.enter.native="login"></el-input>
              <img class="ipt_img" src="@/assets/img/login_new_03.png" alt />
            </el-form-item>
            <el-form-item prop="valueSlider">
              <drag-verify ref="dragVerify" class="verify" :isPassing.sync="dataLogin.valueSlider" :width="272" :height="30" textSize="12px" radius="0px" text="请按住滑块，拖动到最右边" success-text="验证通过" handlerIcon="fa el-icon-d-arrow-right" successIcon="fa el-icon-circle-check"></drag-verify>
            </el-form-item>
            <el-form-item>
              <el-button type="primary login_btn" :loading="loading" @click="login">登录</el-button>
            </el-form-item>
          </el-form>
          <!-- 手机登录 -->
          <el-form v-show="login_Type==='mobile'" ref="formMobile" :model="mobileLogin" :rules="mobileRules" label-width="0px" label-position="left">
            <el-form-item prop="mobile">
              <el-input v-model="mobileLogin.mobile" placeholder="请输入手机号码" clearable></el-input>
              <img class="ipt_img" src="@/assets/img/login_new_04.png" alt />
            </el-form-item>
            <el-form-item class="code" prop="verCode">
              <el-input v-model="mobileLogin.verCode" placeholder="请输入验证码" clearable @keyup.enter.native="loginBymobile"></el-input>
              <img class="ipt_img" src="@/assets/img/login_new_05.png" alt />
              <el-button @click="msgSendVerCode" :disabled="downTimeMsg>0" type="primary send_btn">
                {{downTimeMsg>0?downTimeMsg+'秒后重发':'发送验证码'}}
              </el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="primary login_btn" :loading="loading" @click="loginBymobile">登录</el-button>
            </el-form-item>
          </el-form>
          <!-- 其他共用按钮 -->
          <div class="other">
            <router-link v-show="login_Type==='pwd'" class="item" to="/retrievePwd" target="_blank">忘记密码</router-link>
            <a class="item" href="/register" target="_blank">注册</a>
          </div>
          <!-- 微信登录入口 -->
          <div class="wx_btn com_link" @click="goWXLogin">
            <img src="@/assets/img/wechat_logo.png" alt />
            <span>微信</span>
          </div>
        </div>
        <!-- 微信登录 -->
        <div class="qrcode_box" v-show="login_Type==='wx'">
          <div class="qrcode" id="qrcode"></div>
          <div class="btn_pwd com_link" @click="changeLoginType('pwd')">
            <i class="iconfont icon-denglu-zhanghudenglu" />
            <span>账户</span>
          </div>
          <div class="btn_shouji com_link" @click="changeLoginType('mobile')">
            <i class="iconfont icon-shoujidenglu" />
            <span>手机</span>
          </div>
        </div>
      </div>
    </div>
  </com-solt>
</template>

<script>
import ComSolt from "./components/comSolt";
import dragVerify from "vue-drag-verify2";
import { setLogin } from "@/pages/publicUtils/setLogin";
import {
  checkMobile,
  checkSlider,
  checkVerCode,
} from "@/pages/publicUtils/validate";
export default {
  metaInfo: { title: "欢迎登录" },
  components: { ComSolt, dragVerify },
  name: "login",
  props: {
    LoginByUsername: {
      type: Function,
      default: () => {},
    },
    GetLoginVerCode: {
      type: Function,
      default: () => {},
    },
    LoginByMobile: {
      type: Function,
      default: () => {},
    },
    GetWxWebSiteQrInfo: {
      type: Function,
      default: () => {},
    },
    GetShopInfoNoLogin: {
      type: Function,
      default: () => {},
    },
    isShopView: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      login_Type: "pwd",
      dataLogin: {
        userAccount: "",
        userPwd: "",
        clientType: 0, //pc=0 小程序=1 h5=5 pc_shop=6
        loginType: 0, //平台_商家_C端 = 0,平台_商家 = 1,商家 = 2 C端 = 3,
        valueSlider: false,
      },
      mobileLogin: {
        mobile: "",
        verCode: "",
        clientType: 0, //pc=0 小程序=1 h5=5 pc_shop=6
        loginType: 0, //平台_商家_C端 = 0,平台_商家 = 1,商家 = 2 C端 = 3,
      },
      downTimeMsg: 0,
      rules: {
        userAccount: [{ required: true, message: "必填", trigger: "blur" }],
        userPwd: [{ required: true, message: "必填", trigger: "blur" }],
        valueSlider: [{ validator: checkSlider, trigger: "change" }],
      },
      mobileRules: {
        mobile: [{ validator: checkMobile, trigger: "blur" }],
        verCode: [{ validator: checkVerCode, trigger: "blur" }],
      },
      loading: false,
    };
  },
  mounted() {
    if (this.isShopView) {
      this.dataLogin.clientType = 6;
      this.mobileLogin.clientType = 6;
    }
  },
  methods: {
    changeLoginType(val) {
      this.clearForm();
      this.login_Type = val;
    },
    // 账户登录
    login() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.LoginByUsername(this.dataLogin)
            .then((res) => {
              // console.log("登录返回结果", res);
              this.loading = false;
              this.loginRes(res);
            })
            .catch((err) => {
              this.loading = false;
            });
        } else {
          return false;
        }
      });
    },
    // 手机登录
    msgSendVerCode() {
      this.$refs.formMobile.validateField("mobile", (err) => {
        if (!err) {
          this.GetLoginVerCode({ mobile: this.mobileLogin.mobile }).then(
            (res) => {
              // console.log("获取到的验证码", res);
              this.mobileLogin.verCode = res.data[0].verCode;
              this.downTimeMsg = 60;
              let aTime = setInterval(() => {
                this.downTimeMsg -= 1;
                // console.log(this.downTimeMsg);
                if (this.downTimeMsg <= 0) {
                  clearInterval(aTime);
                }
              }, 1000);
            }
          );
        }
      });
    },
    loginBymobile() {
      this.$refs.formMobile.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.LoginByMobile(this.mobileLogin)
            .then((res) => {
              // console.log("登录返回结果", res);
              this.loading = false;
              this.loginRes(res);
            })
            .catch((err) => {
              this.loading = false;
            });
        } else {
          return false;
        }
      });
    },
    // 微信登陆
    goWXLogin() {
      this.login_Type = "wx";
      this.clearForm();
      this.GetWxWebSiteQrInfo().then((res) => {
        // console.log("获取微信二维码参数",res);
        let data = res.data[0];
        this.createQR(
          data.appId,
          data.scope,
          data.state,
          this.$route.query.redirect
        );
      });
    },
    createQR(appid, scope, state, redirect) {
      // redirect_uri必须www，本地端口改为80
      // 直接访问http://www.duobihouse.com 映射到本地
      let url;
      if (this.isShopView) {
        let config =
          process.env.VUE_APP_BASE_JS === "dev_js" ? configDevId : configProId;
        // 转码 只转参数值和&
        url =
          process.env.NODE_ENV === "development"
            ? "http://www.duobihouse.com/wxLogin?redirect=" + redirect
            : process.env.VUE_APP_BASE_URL +
              "/wxLogin?redirect=" +
              encodeURIComponent(redirect) +
              encodeURIComponent("&") +
              "shopHost=" +
              encodeURIComponent(config.hostName);
      } else {
        url =
          process.env.NODE_ENV === "development"
            ? "http://www.duobihouse.com/wxLogin?redirect=" + redirect
            : process.env.VUE_APP_BASE_URL + "/wxLogin?redirect=" + redirect;
      }
      let obj = new WxLogin({
        self_redirect: true,
        id: "qrcode",
        appid,
        scope,
        state,
        redirect_uri: url,
        style: "black",
        href: "data:text/css;base64,LmltcG93ZXJCb3ggLmluZm8gewogZGlzcGxheTogbm9uZTsKfQ==",
        // href:"data:text/css;base64,css转换的base64"
      });
    },
    // 统一处理
    clearForm() {
      this.$refs.form.resetFields();
      this.$refs.formMobile.resetFields();
    },
    loginRes(res) {
      setLogin(res.data[0]).then(() => {
        let redirect = this.$route.query.redirect || "/";
        let newUrl = this.$router.resolve(redirect);
        window.open(newUrl.href, "_self");
      });
    },
  },
};
</script>

<style lang="less" scoped>
.main {
  background: #ffcb5d;
  height: 600px;
  .content {
    height: 100%;
    box-sizing: border-box;
    padding: 96px 38px;
    background: @themeColor;
    display: flex;
    .img {
      padding: 23px 0 27px;
      width: 342px;
      margin-left: 28px;
    }
    .adv {
      // padding-top: 83px;
      padding-top: 120px;
      margin-left: 50px;
      font-size: 40px;
      font-weight: bold;
      color: #ffffff;
      line-height: 1;
      letter-spacing: 6px;
      .p2 {
        margin-top: 32px;
      }
    }
    .form_box {
      margin-left: 128px;
      width: 336px;
      height: 408px;
      box-sizing: border-box;
      background: #ffffff;
      border-radius: 5px;
      padding: 0 32px;
      position: relative;
      .menu {
        padding-top: 26px;
        display: flex;
        font-size: 16px;
        font-weight: bold;
        .item {
          padding-bottom: 8px;
          margin-right: 20px;
          border-bottom: 2px solid #ffffff;
          cursor: pointer;
          &:last-child {
            margin-right: 0;
          }
        }
        .active {
          border-color: @themeColor;
        }
      }
      /deep/ .el-form {
        margin-top: 18px;
        .el-form-item__content {
          .el-input__inner {
            padding-left: 53px;
            box-sizing: border-box;
          }
          .ipt_img {
            position: absolute;
            left: 1px;
            top: 1px;
            width: 38px;
            height: 38px;
            box-sizing: border-box;
            background: #e5e5e5;
          }
          .login_btn {
            width: 100%;
            border-radius: 0;
          }
        }
        .code {
          .el-form-item__content {
            .el-input__inner {
              padding-left: 53px;
              padding-right: 127px;
              box-sizing: border-box;
            }
            .send_btn {
              position: absolute;
              right: 1px;
              top: 1px;
              border-radius: 0;
              background: #ffffff;
              font-weight: 500;
              color: #b7b7b7;
              height: 38px;
              line-height: 1;
              padding: 0 10px 0 0;
              margin-left: 30px;
              border: none;
            }
            .el-input__suffix {
              right: 100px;
            }
          }
        }
        .pwd_item {
          // 手动加斜杆
          .el-form-item__content {
            input[type="password"] + .el-input__suffix {
              .el-input__icon.el-icon-view.el-input__clear {
                position: relative;
                &::after {
                  width: 16px;
                  height: 1px;
                  background-color: #c0c4cc;
                  display: block;
                  position: absolute;
                  top: 50%;
                  margin-top: -1px;
                  left: 50%;
                  margin-left: -8px;
                  transform: rotate(-45deg);
                  -ms-transform: rotate(-45deg); /* IE 9 */
                  -moz-transform: rotate(-45deg); /* Firefox */
                  -webkit-transform: rotate(-45deg); /* Safari 和 Chrome */
                  -o-transform: rotate(-45deg); /* Opera */
                }
                &:hover {
                  &::after {
                    background-color: #909399;
                  }
                }
              }
            }
          }
        }
      }
      .other {
        margin-top: 22px;
        text-align: right;
        font-size: 12px;
        font-weight: 500;
        .item {
          padding-left: 12px;
          color: #333333;
        }
      }
      .wx_btn {
        position: absolute;
        bottom: 24px;
        right: 34px;
        font-size: 14px;
        font-weight: 500;
        color: #333333;
        cursor: pointer;
        img {
          vertical-align: middle;
          width: 36px;
          height: 36px;
        }
      }
    }
    .qrcode_box {
      margin-left: 128px;
      width: 336px;
      height: 408px;
      box-sizing: border-box;
      background: #ffffff;
      border-radius: 5px;
      display: flex;
      justify-content: center;
      position: relative;
      .btn_pwd {
        position: absolute;
        bottom: 10px;
        left: 10px;
        color: rgb(40, 153, 251);
        i {
          margin-right: 4px;
        }
      }
      .btn_shouji {
        position: absolute;
        bottom: 10px;
        right: 10px;
        color: rgb(234, 107, 101);
        i {
          margin-right: 4px;
        }
      }
    }
  }
}
</style>